var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7674 10.0002L19.6338 2.13472C20.1221 1.64642 20.1221 0.854731 19.6338 0.366469C19.1455 -0.121831 18.3538 -0.121831 17.8655 0.366469L9.99997 8.23279L2.13447 0.366469C1.64617 -0.121831 0.854487 -0.121831 0.366225 0.366469C-0.122036 0.85477 -0.122075 1.64646 0.366225 2.13472L8.23254 10.0002L0.366225 17.8658C-0.122075 18.3541 -0.122075 19.1457 0.366225 19.634C0.854526 20.1223 1.64621 20.1223 2.13447 19.634L9.99997 11.7676L17.8655 19.634C18.3538 20.1223 19.1455 20.1223 19.6337 19.634C20.122 19.1457 20.122 18.354 19.6337 17.8658L11.7674 10.0002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.9225f8b11cc666a0b7375a4fe8cb85c4.svg";
export { ForwardRef as ReactComponent };